import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UnifiedAlert } from '../../../services/unified-alert.service';

/**
 * Aperçu des alertes (météo, événements, ruptures) pour les plans sans AUTO_ALERTS (Starter) :
 * indique qu'il y a des alertes et laisse voir la première, sans impact chiffré ni détail,
 * pour donner envie de passer à Pro.
 *
 * Usage : <app-alert-preview [alerts]="unifiedAlerts" [extraCount]="merchantAlerts.length" />
 */
@Component({
  selector: 'app-alert-preview',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div
      class="rounded-lg border border-dashed border-purple-300 dark:border-purple-800 bg-purple-50/60 dark:bg-purple-900/10 p-4"
    >
      @if (count() > 0) {
        <p class="font-semibold text-gray-900 dark:text-white">
          {{ count() }} alerte{{ count() > 1 ? 's' : '' }} détectée{{
            count() > 1 ? 's' : ''
          }}
          pour vos prochains jours
        </p>
        @if (first(); as alert) {
          <p class="mt-2 text-sm text-gray-700 dark:text-gray-300">
            <span class="mr-1">{{ alert.icon }}</span
            >{{ alert.title }}
          </p>
        }
        <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
          L'impact chiffré, le détail et les alertes automatiques sont inclus
          avec Pro.
        </p>
      } @else {
        <p class="text-sm text-gray-700 dark:text-gray-300">
          Alertes météo et risques de rupture : incluses avec Pro.
        </p>
      }
      <a
        routerLink="/subscription"
        class="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white rounded-full text-xs font-semibold hover:bg-purple-700 transition"
      >
        <span>🔒</span> Débloquer avec Pro
      </a>
    </div>
  `,
})
export class AlertPreviewComponent {
  readonly alerts = input<UnifiedAlert[]>([]);
  /** Alertes supplémentaires non listées (ex. alertes ruptures / pertes du cluster). */
  readonly extraCount = input(0);

  readonly count = computed(() => this.alerts().length + this.extraCount());
  readonly first = computed(() => this.alerts()[0] ?? null);
}
